<template>
<div class="sold-acc" v-loading="loading">
  <latestnews></latestnews>
  <pricelist :title="'已售账号'" :data="goodList" :page="goodsPage" @showlogin="showLogin" :type="2"
  @changepage="changeGoodsPage" @changepagesize="changeGoodsPageSize"></pricelist>
</div>

</template>

<script>
import latestnews from '@/components/common/latestnews/latestNews'
import pricelist from '@/components/common/pricelist/priceList'
import { mapState } from 'vuex'
import { saleResource } from '@/resource/resource'

const ERR_OK = 0

export default {
  name: 'soldAcc',
  data () {
    return {
      goodList: [],
      goodsPage: {
        'page_current': 1,
        'page_size': 20,
        'total_count': 8,
        'total_page': 1
      },
      loading: false,
      goods_page_size: 10
    }
  },
  computed: {
    ...mapState(['userInfo', 'logined', 'config_info'])
  },
  created() {
    this.goods_page_size = this.config_info.service_sold_limit
    this.getGoodList({type: 2, count: this.goods_page_size})
  },
  methods: {
    getGoodList (params) {
      this.loading = true
      saleResource.list(params).then(res => {
        res = res.body
        this.loading = false
        if (res.errcode === ERR_OK) {
          this.goodList = res.data
          this.goodsPage = res.page
          // this.goods_page_size = this.goodsPage.page_size
        }
      })
    },
    changeGoodsPage(val) {
      this.getGoodList({type: 2, count: this.goods_page_size, page: val - 1})
    },
    changeGoodsPageSize(size) {
      this.goods_page_size = size
      this.getGoodList({type: 2, count: size})
    },
    showLogin() {
      this.$emit('showlogin', true)
    }
  },
  components: {
    latestnews,
    pricelist
  }
}
</script>

<style lang="stylus" scoped>
.sold-acc
  width 1000px
  margin 0 auto
</style>




// WEBPACK FOOTER //
// soldAcc.vue?d64756d8